@if (tags && tags.length > 0) {
  <ul class="sh-tag-list">
    @for (tag of tags; track tag; let i = $index) {
      <li class="sh-tag--subtle sh-tag-list__item -sh-truncate" [title]="tag">
        <span class="sh-tag__label">{{ tag }}</span>
        <button [id]="'suggestion-tag-list-tag-' + i + '-add-action'" type="button" class="sh-tag__button" (click)="onAccept(tag)">
          <svg sh-icon [name]="'check'" [size]="IconSize.SMALL" aria-hidden="true" class="sh-tag__icon"></svg>
        </button>
        <button [id]="'suggestion-tag-list-tag-' + i + '-remove-action'" type="button" class="sh-tag__button" (click)="onRemove(tag)">
          <svg sh-icon [name]="'close'" [size]="IconSize.SMALL" aria-hidden="true" class="sh-tag__icon"></svg>
        </button>
      </li>
    }
  </ul>
} @else {
  @if (noTagsMessage) {
    <ul class="sh-tag-list">
      <li class="sh-tag--readonly sh-tag-list__item -sh-truncate" [title]="noTagsMessage">
        <span class="sh-tag__label">{{noTagsMessage}}</span>
      </li>
    </ul>
  }
}
